<template>
  <div class="card config">
    <div class="config__header">
      <h4 class="title">
        {{ translate('config.config') }}
      </h4>
    </div>

    <div class="config__content">
      <p class="header">
        <span>{{ translate('config.username') }}: {{ info.username }}</span>
        <span>{{ translate('config.ver') }}: {{ info.ver }}</span>
        <span>{{ translate('config.ts') }}: {{ get_date(info.ts) }}</span>
      </p>
      <textarea v-model="info.config.main"/>
    </div>

    <div class="config__button">
      <button
          class="btn btn-success btn-fill btn-wd"
          @click.prevent="save_config"
      >
        {{ translate('config.apply') }}
      </button>
      <button
          class="btn btn-danger btn-fill btn-wd"
          @click.prevent="cancel"
      >
        {{ translate('close_modal') }}
      </button>
    </div>
  </div>
</template>
<script>

export default {
  props: ['data'],

  data () {
    return {
      info: {}
    }
  },
  computed:{
    fid(){
      return this.$route.params.device_id
    }
  },
  created(){
    this.get_config()
  },
  methods: {
    get_config(){
      this.$http.v1.getConfigByVersion(this.fid, {ver: this.data}, (response) => {
        this.info = response.data
      })
    },
    save_config () {
      this.$http.v1.saveDeviceConfig(this.fid, {fid: this.fid, config: this.info.config }, () => {
        this.global_notify('info', this.translate('config.saved_success'))
        this.$emit('update')
        this.$emit('close')
      })
    },
    cancel () {
      this.$emit('close')
    },
  }
}

</script>

<style lang='scss' scoped>

.config{
  &__header{
    padding: 20px 10px 10px;
    .title{
      font-size: 22px;
      font-weight: 600;
      text-align: center;
    }
  }
  &__content{
    padding: 10px;
    height: 400px;
    .header{
      display: flex;
      justify-content: space-between;
      margin: 0;
      padding: 0;
      height: 5%;
      margin-bottom: 5px;
    }
    textarea{
      flex: 10;
      width: 100%;
      height: 95%;
      overflow: auto;
      outline: none;
      &::-webkit-scrollbar {
        width: 10px;
      }
    }
  }
  &__button{
    display: flex;
    justify-content: center;
    align-items: center;
    .btn{
      margin: 0 5px;
    }
  }
}
@media (max-width:600px) {
  .config{
    &__form{
      &-row{
        flex-direction: column;
        &__input{
          width: 100%;
        }
      }
    }
  }
}

</style>
